// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2WGaB","balanceDisclaimer":"posDashboard_balanceDisclaimer__1WbDL"};